// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/Apps/Content/mutation-install.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_ConnectApps_Apps_Content($app_id: uuid!, $properties: [AppProperty!]) {
  apps_install(app_id: $app_id, properties: $properties) {
    app {
      id
      companies {
        id
        status
        properties: metadata(path: "properties")
      }
    }
  }
}

`